module.exports = __webpack_public_path__ + "img/zhanghu_yue.18e29599.png";